import { createContext, Dispatch, ReactPortal, SetStateAction } from 'react';

interface IModalContext {
  portal: ReactPortal | null;
  secondaryPortal: ReactPortal | null;
  setPortal: Dispatch<SetStateAction<ReactPortal | null>>;
  setSecondaryPortal: Dispatch<SetStateAction<ReactPortal | null>>;
  portalWrapper: HTMLDivElement | null;
  secondaryPortalWrapper: HTMLDivElement | null;
  setPortalWrapper: Dispatch<SetStateAction<HTMLDivElement | null>>;
  setSecondaryPortalWrapper: Dispatch<SetStateAction<HTMLDivElement | null>>;
}

const initialValue: IModalContext = {
  portal: null,
  secondaryPortal: null,
  setPortal: () => void {},
  setSecondaryPortal: () => void {},
  portalWrapper: null,
  secondaryPortalWrapper: null,
  setPortalWrapper: () => void {},
  setSecondaryPortalWrapper: () => void {},
};

const ModalContext = createContext<IModalContext>(initialValue);

export default ModalContext;
